import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Icon from '../../elementals/icon';
import cls from './styles.scss';
const cx = classnames.bind(cls);
const PropertySaveIndicator = ({ elmId, property = {}, onSaveToggle, isCancelled = false, }) => {
    const isSaved = property.is_currently_saved;
    const iconBaseColor = isSaved ? 'error' : 'white';
    const iconHoverColor = isSaved ? 'error' : 'grayExtraLight';
    const iconStyle = isSaved ? 'solid' : 'regular';
    return (_jsx(Icon, { color: iconBaseColor, className: cx('save-indicator', { 'is-saved': isSaved }, { disabled: isCancelled }), "data-elm-id": `save_property_icon_${elmId}`, hoverColor: iconHoverColor, name: 'heart', iconStyle: iconStyle, onClick: () => onSaveToggle(property), size: 'large' }));
};
PropertySaveIndicator.propTypes = {
    elmId: PropTypes.string.isRequired,
    property: PropTypes.shape({
        property_id: PropTypes.string.isRequired,
        is_currently_saved: PropTypes.bool,
    }).isRequired,
    onSaveToggle: PropTypes.func,
    isCancelled: PropTypes.bool,
};
export default PropertySaveIndicator;
//# sourceMappingURL=index.js.map